import { Container } from "@chakra-ui/react";
import styles from "./team.module.scss";
import TeamCard from "../../components/team";
import { useEffect, useState } from "react";
import { useGetTeam } from "../../queries/team";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export type TeamMember = {
  name: string;
  title: string;
  photo: string;
  bio: string;
  linkedin: string;
};

const Team = () => {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const { data: teamData } = useGetTeam();
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.3 });
  const { elementRef: teamRef, isVisible: teamVisible } = useScrollAnimation({ threshold: 0.1 });

  useEffect(() => {
    if (teamData) setTeamMembers(teamData?.teamMembers);
  }, [teamData]);

  return (
    <div className={`sectionContainer ${styles.teamSection}`} id="team">
      <Container>
        <div
          ref={titleRef}
          className={`${styles.teamTitle} fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <h2 className="sectionSubtitle">Our team</h2>
          <p>
            Our solutions are build around our team of diverse process experts
            and machine learning experts. We will help you with project scoping
            to setup and onwards to routine maintenance
          </p>
        </div>
        <div
          ref={teamRef}
          className={`${styles.teamContainer} stagger-children ${teamVisible ? 'visible' : ''}`}
        >
          {teamMembers?.map((member, index) => (
            <TeamCard {...member} key={index} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Team;
